import { IIxTreeNode } from './IIxTreeNode.js';

export function findChildNodeById(
  node: IIxTreeNode,
  id: string
): IIxTreeNode | null {
  if (node.id === id) {
    return node;
  }
  if (!node.children) {
    return null;
  }

  for (const childNode of node.children) {
    const foundNode = findChildNodeById(childNode, id);

    if (foundNode) {
      return foundNode;
    }
  }

  return null;
}

export function updateNodeCheckedStatus(
  node: IIxTreeNode,
  rootNode: IIxTreeNode,
  rollup: boolean = true,
  disableChildrenOnParentCheck: boolean = false,
  cascadeCheckToChildren: boolean = true
): void {
  /* eslint-disable no-param-reassign */
  function updateChildren(n: IIxTreeNode, checked = false): void {
    if (n.fixed) return;
    n.checked = checked;
    n.indeterminate = false;
    if (n.children && cascadeCheckToChildren) {
      n.children.forEach(child => {
        // If the child node is fixed, skip resetting its checked status
        // and do not update its children
        if (child.fixed) return;

        if (disableChildrenOnParentCheck) {
          child.disabled = n.checked;
        }
        updateChildren(child, checked);
      });
    }
  }
  function updateParents(n: IIxTreeNode): void {
    if (n.parentId) {
      const currentParent = findChildNodeById(rootNode, n.parentId);
      if (currentParent && currentParent.children) {
        if (currentParent.children.every(child => child.checked) && rollup) {
          currentParent.checked = true;
          currentParent.indeterminate = false;
        } else if (currentParent.children.some(child => child.checked)) {
          currentParent.checked = false;
          currentParent.indeterminate = true;
        } else if (currentParent.children.some(c => c.indeterminate)) {
          currentParent.checked = false;
          currentParent.indeterminate = true;
        } else {
          currentParent.checked = false;
          currentParent.indeterminate = false;
        }
        updateParents(currentParent);
      }
    }
  }
  // update all children to match current node checked status
  if (cascadeCheckToChildren) {
    updateChildren(node, node.checked);
  }

  // update all parents checked and indeterminate status
  // Skip parent updates when cascadeCheckToChildren is false (independent mode)
  if (cascadeCheckToChildren) {
    updateParents(node);
  }
}
